var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoogle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_128_87)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.771 8.11127H10.1687V11.999H15.5911C15.491 12.6132 15.2576 13.1989 14.9067 13.7164C14.5558 14.234 14.0957 14.6711 13.5577 14.9982C12.5477 15.6416 11.372 15.9884 10.1687 15.9979C8.91024 15.9723 7.69095 15.5631 6.67917 14.8269C5.66738 14.0907 4.91302 13.0638 4.52024 11.888C4.29853 11.2821 4.18391 10.6435 4.18133 9.99962C4.17398 9.35493 4.28891 8.71454 4.52024 8.11127C4.91302 6.93544 5.66738 5.90851 6.67917 5.17232C7.69095 4.43612 8.91024 4.02696 10.1687 4.00134C11.5854 4.00486 12.9518 4.51856 14.0096 5.44537L16.9468 2.55731C15.1164 0.863355 12.6816 -0.0543675 10.1687 0.00249303C8.28147 -0.0107159 6.42944 0.504549 4.82906 1.48806C3.22869 2.47156 1.94609 3.88268 1.13119 5.55645C0.413863 6.93301 0.027383 8.45308 0.00150686 9.99962C-0.0274833 11.5528 0.362286 13.0858 1.13119 14.4428C1.97656 16.093 3.26625 17.4835 4.8598 18.4628C6.45334 19.4421 8.28963 19.9727 10.1687 19.9967C12.6621 20.0605 15.0863 19.1865 16.9468 17.553C17.9428 16.6046 18.7281 15.4635 19.2531 14.2017C19.7781 12.9398 20.0314 11.5847 19.9969 10.2218C19.9835 9.51319 19.9079 8.80707 19.771 8.11127Z",
    fill: "#0D111A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_128_87"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.a12adc39.svg";
export { ForwardRef as ReactComponent };